import AdminGuard from '@/views/dashboard/guards/AdminGuard'
import Data from './Data.vue'

export default [
    { path: 'data-dasar', component: Data, beforeEnter: AdminGuard, name: 'base-data', meta: { title: 'Data Dasar' } },
]
